import {
    initCtaSectionAnimations,
    initFeatureHighlight,
    initForWhoSectionAnimations,
    initHeroSectionAnimations,
    initHowToSectionAnimations,
    initPhoneModelAnimations,
    initStatCounters,
    initStatsSectionAnimations,
    initTestimonialsSectionAnimations,
    initVideoSwitcher,
} from "./utils";

/**
 * BOOTSTRAP
 */
initHeroSectionAnimations();
initVideoSwitcher();
initFeatureHighlight();
initHowToSectionAnimations();
initForWhoSectionAnimations();
initTestimonialsSectionAnimations();
initCtaSectionAnimations();
initStatsSectionAnimations();
initStatCounters();
initPhoneModelAnimations();
